export default __webpack_public_path__ + "static/media/checkmark.24e28fec.svg";